import { apiResolver, useApi } from "@/api/useApi";
import { CopilotConfigResponse } from "@/components/quack-chat/QuackChatConfig.model";
import { useConfigManager } from "./useConfigManager";

export function useCopilotConfiguration() {
  const { api } = useApi();

  return useConfigManager<CopilotConfigResponse, CopilotConfigResponse, void>({
    name: "quackchat-session-configuration",
    getConfig: async () =>
      apiResolver<CopilotConfigResponse>(
        api.get(`/platform/extension-admin/configuration`)
      ),
    updateConfig: async (request, signal) =>
      apiResolver<void>(
        api.put(`/platform/extension-admin/configuration`, request, { signal })
      ),
  });
}
